// extracted by mini-css-extract-plugin
module.exports = {"App":"styles_App__35Xrx","mainPage":"styles_mainPage__3ddGo"};